import styled from 'styled-components';

export const ModalOverlay = styled.div``;

export const FabNewJourneyContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  & span {
    display: block;
  }
`;

export const FabNewJourneyImg = styled.img`
  width: 100%;
`;
